import vuex from "vuex"
import vue from "vue"
import vapi from "vuex-rest-api"
vue.use(vuex);

// Store
const plurianual = new vapi({
    baseURL: `${process.env.VUE_APP_REST}/api/plurianual`,
    namespaced : true,        
    state: {
        rplurianualfuente: [],
        rplurianualpuntopilar: []
    }
}).get({
    action: "get_plurianualfuentes", 
    path: function () {
        return `/fuente`;
    },        
    onSuccess: (state, payload) => {        
        state.rplurianualfuente = payload.data;
    }
}).get({
    action: "get_plurianualpuntopilar", 
    path: function () {
        return `/puntopilar`;
    },        
    onSuccess: (state, payload) => {        
        state.rplurianualpuntopilar = payload.data;
    }
}).getStore();

plurianual.getters = {  
   
    gplurifuente : state =>  {
        return state.rplurianualfuente;
    },
    gpluripuntopilar : state =>  {
        return state.rplurianualpuntopilar;
    }    
}

export default plurianual;
